import { CreateList } from "../../Functional/SelectList";
import { useLocation } from "react-router-dom";
import { LIST_TYPES } from "../../../constants/listTypes";

const AddToSelectList = props => {
  const { currentSlide, images, targetListId } = props || {};
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const selectedListId =
    targetListId ||
    Number(queryParams.get("imageListId")) ||
    Number(queryParams.get("imageWorkingListId")) ||
    undefined;

  const { archiveId, artworkId } = images[currentSlide];
  const id = `${archiveId},${artworkId}`;

  const createProps = {
    label: "Add to Image Select List",
    typeId: LIST_TYPES.INSTANCE_IMAGE_WORKING,
    ids: [id],
    targetListId: selectedListId,
  };

  return <CreateList {...createProps} />;
};

export default AddToSelectList;
